import React from 'react';
import { Form, Input, Select } from 'antd';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

import AddEditStore from './store';

@observer
class ReportDeliveryContact extends React.Component {
  render() {
    const { staffAllList } = AddEditStore;
    const data = toJS(AddEditStore.clientInfo);
    return (
      <Form name="report-delivery-contact-form">
        <Form.Item label="Contact Name">
          <Input
            size="large"
            value={data.AccContact}
            onChange={AddEditStore.handleFieldChange('AccContact')}
          />
        </Form.Item>
        <Form.Item label="Accounting Email">
          <Input
            size="large"
            value={data.AccEmail}
            onChange={AddEditStore.handleFieldChange('AccEmail')}
          />
        </Form.Item>
        <Form.Item label="Phone">
          <Input
            size="large"
            value={data.AccPhoneNumber}
            onChange={AddEditStore.handleFieldChange('AccPhoneNumber')}
          />
        </Form.Item>
        <Form.Item label="Report Delivery Contact">
          <Select
            size="large"
            value={data.ReportDeliveryContact}
            onChange={AddEditStore.handleFieldChange('ReportDeliveryContact')}
          >
            {staffAllList &&
              staffAllList.itemList.map(i => (
                <Select.Option key={i.Id} value={i.Id}>
                  {i.Id} - {i.FullName}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </Form>
    );
  }
}

export default ReportDeliveryContact;
